export default __webpack_public_path__ + "static/media/Reserva-Salas-PT.8cc24ac8.png";